import { jsx } from 'panel';
import { InputEl } from 'common/components/input';
import { ButtonEl } from 'common/components/button';
import { TooltipEl } from 'common/components/tooltip';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
export function template() {
  return jsx("div", {
    sel: '.mp-copy-to-clipboard'
  }, jsx(InputEl, {
    sel: '.copy-input',
    attrs: {
      readonly: true,
      type: "text",
      label: this.attr("label")
    },
    props: {
      value: this.attr("value")
    },
    hook: {
      insert: (_ref) => {
        let {
          elm
        } = _ref;
        return this.helpers.handleInsert(elm);
      }
    }
  }), jsx("div", {
    sel: '.copy-button'
  }, jsx(ButtonEl, {
    attrs: {
      icon: "duplicate",
      theme: ButtonTheme.Tertiary,
      size: ButtonSize.Large
    },
    on: {
      click: this.helpers.copyValue
    }
  }, "Copy"), jsx(TooltipEl, null, " ", this.state.isCopied ? "Copied!" : "Copy")));
}